export default __webpack_public_path__ + "static/media/purple-card.bb34fdc2.png";